export var NBA_CLICKSTREAM_EVENT_TYPE = {
  IMPRESSION: 'impression',
  INTENT_TO_SHOW: 'intent_to_show',
  INTERACTION: 'interaction'
};

var VIEW_TRIGGER_SOURCE_VALUE = function VIEW_TRIGGER_SOURCE_VALUE(value) {
  return "onsite_message_component|" + value;
};

var INTERACT_TRIGGER_SOURCE_VALUE = function INTERACT_TRIGGER_SOURCE_VALUE(value) {
  return "button_to_interact_with_" + value + "_onsite_message";
};

export var NBA_CLICKSTREAM_SCHEMA_DATA = function NBA_CLICKSTREAM_SCHEMA_DATA(triggerLocation, triggerObject, triggerSource) {
  var _ref;

  return _ref = {}, _ref[NBA_CLICKSTREAM_EVENT_TYPE.INTENT_TO_SHOW] = {
    envelopeBlock: {
      event_template_id: '245',
      event_template_version_id: '1',
      event_type_id: '3828',
      event_type_version_id: '3'
    },
    triggerBlock: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'impression',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: VIEW_TRIGGER_SOURCE_VALUE(triggerSource)
    },
    semanticBlock: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['nba']
    },
    nbaBlock: {
      event_subtype_cd: 'selection'
    }
  }, _ref[NBA_CLICKSTREAM_EVENT_TYPE.IMPRESSION] = {
    envelopeBlock: {
      event_template_id: '245',
      event_template_version_id: '1',
      event_type_id: '3829',
      event_type_version_id: '3'
    },
    triggerBlock: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'impression',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: VIEW_TRIGGER_SOURCE_VALUE(triggerSource)
    },
    semanticBlock: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['nba']
    },
    nbaBlock: {
      event_subtype_cd: 'impression'
    }
  }, _ref[NBA_CLICKSTREAM_EVENT_TYPE.INTERACTION] = {
    envelopeBlock: {
      event_template_id: '245',
      event_template_version_id: '1',
      event_type_id: '3830',
      event_type_version_id: '3'
    },
    triggerBlock: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: INTERACT_TRIGGER_SOURCE_VALUE(triggerSource)
    },
    semanticBlock: {
      semantic_event_nm: 'nba_content_interaction',
      topic_tag_txt: ['nba']
    },
    nbaBlock: {
      event_subtype_cd: 'reaction'
    }
  }, _ref;
};